import Cookies from 'js-cookie'

const TokenKey = 'token'
const UserName = 'username'
export function getToken() {
    return Cookies.get(TokenKey)
}

export function setToken(token) {
    return Cookies.set(TokenKey, token)
}

export function removeToken() {
    return Cookies.remove(TokenKey)
}
export function getUsername() {
    return Cookies.get(UserName)
}
export function setUsername(username) {
    return Cookies.set(UserName, username)
}
